import React from 'react';
import { Box } from '@mui/material';
import { useSearchParams } from 'react-router';

import { MobilePropertiesSection } from './properties-section';
import { PlanDetailViewMobile } from './plan-detail-view-mobile';

import type { PropertyPlansApiResponse } from '../../types/plan.types';

import { convertDateTimeFormat } from '@/utils/date-time';
import { SELECTED_PLAN_ID_PARAM } from '@/lib/constants';

interface PlanEditViewMobileProps {
  planDetail: PropertyPlansApiResponse | null;
}

/**
 * Mobile version of PlanEditView
 * View-only interface for mobile devices
 * Displays property details and plan deliveries in a simple card format
 */
export const PlanEditViewMobile: React.FC<PlanEditViewMobileProps> = ({ planDetail }) => {
  const property = planDetail?.property;
  const planDeliveries = planDetail?.planDeliveries || [];
  const [searchParams] = useSearchParams();
  const selectedPlanId = searchParams.get(SELECTED_PLAN_ID_PARAM);

  // formatStaff now always returns string or null, so we can use nullish coalescing
  const createdStaff = property?.createdStaff ?? property?.createdUser;
  const updatedStaff = property?.updatedStaff ?? property?.updatedUser;
  const constructionCompany =
    property?.constructionCompany?.nameAbbreviation?.trim() ||
    property?.constructionCompanyName?.trim() ||
    property?.constructionCompany?.name?.trim() ||
    '';

  return (
    <Box sx={{ width: '100%', py: 2, px: 2 }}>
      <MobilePropertiesSection
        siteAbbreviation={property?.nameAbbreviation || ''}
        salesRepresentative={property?.salestaffName || ''}
        constructionCompany={constructionCompany}
        registrant={createdStaff || ''}
        registrationDateTime={property?.createdAt ? convertDateTimeFormat(property.createdAt) : ''}
        updater={updatedStaff || ''}
        updateDateTime={property?.updatedAt ? convertDateTimeFormat(property.updatedAt) : ''}
      />
      <PlanDetailViewMobile
        planDeliveries={planDeliveries}
        scrollToDeliveryId={selectedPlanId || undefined}
      />
    </Box>
  );
};
